// extracted by mini-css-extract-plugin
module.exports = {"svgIcon":"INP90","autoSize":"DUp42","isClickable":"_18ETu"};